<template>
  <div :class="['title', toApp === '' ? '' : 'title-app']">
    <div :class="['title-inner', toApp === '' ? '' : 'title-app-inner']">
      <div class="title-return" v-if="type !== 'noBtn'">
        <div
          class="title-return-btn"
          @click="goBack"
          v-if="type === 'normal' || type === 'confirmBack'"
        ></div>
        <div class="title-close-btn" @click="close" v-if="type === 'model'"></div>
      </div>
      <slot></slot>
    </div>
  </div>
</template>

<style lang="stylus" scoped>
@import "../styles/variable.styl";
.title {
  flex-shrink: 0;
  position: relative;
  color: $ucar_main_color;
  font-size: 32px;
  text-align: center;
  line-height: 88px;
  height: 88px;

  .title-inner {
    position: absolute;
    top: 0;
    height: 88px;
    left: 0;
    right: 0;
    z-index: 9;
    background-color: $ucar_dark_bg;
    .title-return {
      position: absolute;
      width: 100px;
      left: 0;
      top: 0;
      bottom: 0;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      .title-return-btn,
      .title-close-btn {
        width: 40px;
        height: 40px;
        overflow: hidden;

        &.title-return-btn::before, &.title-return-btn::after {
          content: "";
          background: currentColor;
          position: absolute;
          height: 2px;
          width: 25%;
          top: 50%;
          left: 50%;
          transform-origin: 0 50%;
        }

        &.title-return-btn::before {
          transform: translate3d(-50%, -50%, 0) rotate(45deg);
        }

        &.title-return-btn::after {
          transform: translate3d(-50%, -50%, 0) rotate(-45deg);
        }

        &.title-close-btn::before, &.title-close-btn::after {
          content: "";
          position: absolute;
          background: currentColor;
          width: 2px;
          height: 40%;
          top: 50%;
          left: 50%;
        }

        &.title-close-btn::before {
          transform: translate3d(-50%, -50%, 0) rotate(45deg);
        }

        &.title-close-btn::after {
          transform: translate3d(-50%, -50%, 0) rotate(-45deg);
        }
      }
    }
  }
  
  .title-app-inner {
    background-color: #313339;
  }
}

.title-app {
  position: fixed;
  width: 100%;
  font-size: 36px;
  color: #fff;
  z-index: 999;
} 

</style>

<script>
import ucarStorage from '../utils/storage.js'
import { popView } from "../utils/jsBridge/jsBridge.js";
import { mapGetters } from 'vuex'
export default {
  props: {
    type: {
      type: String,
      default: 'normal'
    },
    text: {
      type: String,
      default: '确认要登出网站吗?'
    },
    okText: {
      type: String,
      default: '确定'
    },
    cancelText: {
      type: String,
      default: '取消'
    },
    to: {
      type: String,
      default: ''
    },
    toApp: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters(['vuexIndexUrl'])
  },
  methods: {
    goBack () {
      if (this.type === 'confirmBack') {
        this.$alert({
          type: 'confirm',
          dsc: this.text,
          showCancel: true,
          center: true,
          okText: this.okText,
          cancelText: this.cancelText,
          callback: () => {
            const url = this.vuexIndexUrl || '/'
            ucarStorage.removeSession('ucar-login-status')
            ucarStorage.removeStorage('carInfo')
            ucarStorage.removeStorage('carPhotoInfo')
            ucarStorage.removeStorage('routeTo')
            ucarStorage.removeStorage('mobile')
            ucarStorage.removeStorage('recruitId')
            ucarStorage.removeStorage('idCard')
            ucarStorage.removeStorage('photoInfo')
            this.$router.push(url)
          }
        })
        return
      }
      if (this.to) {
        this.$router.replace(this.to)
        return
      }
      if (this.toApp) {
        console.log('1111111111111');
       popView()
        return
      }
      this.$router.back()
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>
